import { useFlags } from 'flagsmith/react';
import { useMoonChainKeyParam } from 'hooks/useMoonChainParam';
import { useRouter } from 'next/router';
import { parseJson } from 'utils/json';

export function useIsProxyAvailableFlag(): boolean {
  const { route } = useRouter();
  const page = route?.split('/').at(2);
  const chain = useMoonChainKeyParam();
  const { use_proxy: flag } = useFlags(['use_proxy']);
  const value = parseJson(flag.value);

  if (!flag.enabled || !value || !page) {
    return false;
  }

  return value[chain]?.[page] === true;
}
